import {
  ALGOLIA_NEURAL_SEARCH_PER_TENANT_EXPERIMENT,
  SEARCH_BOX_SUGGESTED_PRODUCT_CLICK,
  SERP_PRODUCT_DETAIL_CLICK,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import trackOptimizelyEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import store from 'shared/store'

const attachEventListeners = () => {
  const searchBoxSuggestedProductEl =
    '[data-clientside-hook="SearchBoxListItemLink"]'
  const searchPageResultProductEl =
    '[data-clientside-hook="FilteredProductListItem"]'

  document.addEventListener('click', (event: Event) => {
    const target = event.target as Element
    if (target.closest(searchBoxSuggestedProductEl)) {
      trackOptimizelyEvent(SEARCH_BOX_SUGGESTED_PRODUCT_CLICK)
    }
    if (target.closest(searchPageResultProductEl)) {
      trackOptimizelyEvent(SERP_PRODUCT_DETAIL_CLICK)
    }
  })
}

export default () => {
  const { tenant } = store.getState()?.publicRuntimeConfig.publicConfig || {}

  const experimentName =
    ALGOLIA_NEURAL_SEARCH_PER_TENANT_EXPERIMENT[tenant]?.desktop

  if (!experimentName) {
    return
  }

  const experiment = getExperimentOnClient(experimentName)

  if (!experiment.isEnabled) {
    return
  }
  attachEventListeners()

  const searchBoxElDesktop = '#h-SearchBox'
  const searchBoxElMobile =
    '[data-clientside-hook="h-SearchBox__trigger--mobile"]'

  document.addEventListener(
    'click',
    event => {
      const target = event.target as Element
      if (
        target.closest(searchBoxElDesktop) ||
        target.closest(searchBoxElMobile)
      )
        void activateExperiment(experimentName)
    },
    { once: true }
  )
}
